module.exports = __webpack_public_path__ + "img/index07.6be17c24.svg";